export default "__VITE_ASSET__8d15e5d0__"